import type { FieldValidator } from 'final-form'

export type Validator = (value: string | undefined, allValues: object) => string | undefined

export const required =
  (err: string): Validator =>
    (value) =>
      value ? undefined : err

export const match =
  (err: string, pattern: RegExp): Validator =>
    (value = '') =>
      pattern.test(value) ? undefined : err

export const maxLength =
  (err: string, length: number): Validator =>
    (value) =>
      value && value.length > length ? err : undefined

export const composeValidators =
  (...validators: ReadonlyArray<Validator>): FieldValidator<string> =>
    (value, allValues) => {
      for (const validator of validators) {
        const error = validator(value, allValues)
        if (error) {
          return error
        }
      }
    }
